import GifAiBulkEditorTagsAndCategoriesPage from "@faire/prototype-playground/workspace/js/gif-ai-bulk-editor-tags-and-categories";
import GifAiBulkProductDescriptionsPage from "@faire/prototype-playground/workspace/js/gif-ai-bulk-product-descriptions";
import StreamlineDtFsPaymentsPage from "@faire/prototype-playground/workspace/js/streamline-dtfs-payments";
import { Route, Switch } from "react-router-dom";

import CopyHoverExplorationsPage from "../../workspace/js/copy-hover-explorations";

export function JasmineShenRoutes() {
  return (
    <Switch>
      <Route
        path="/js/copy-hover-explorations"
        component={CopyHoverExplorationsPage}
      />
      <Route
        path="/js/gif-ai-bulk-editor-tags-and-categories"
        component={GifAiBulkEditorTagsAndCategoriesPage}
      />
      <Route
        path="/js/gif-ai-bulk-product-descriptions"
        component={GifAiBulkProductDescriptionsPage}
      />
      <Route
        path="/js/streamline-dtfs-payments"
        component={StreamlineDtFsPaymentsPage}
      />
    </Switch>
  );
}

export const slug = "js";
